import { X } from "lucide-react";
import { useEffect } from "react";

export default function SizeGuideModal({ open, onClose }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="size-guide-modal"
    >
      <div
        className="relative bg-white max-w-2xl w-full max-h-[90vh] overflow-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 w-9 h-9 bg-black text-white rounded-full flex items-center justify-center hover:bg-magenta transition-colors z-10"
          aria-label="Fermer"
          data-testid="size-guide-close"
        >
          <X size={18} />
        </button>
        <img
          src="/size_guide_tshirt.jpg"
          alt="Guide des tailles T-Shirt"
          className="w-full h-auto block"
        />
      </div>
    </div>
  );
}
